import React from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import { sidelogo } from "../../../assets/exports";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { slideshow } from "../../common/constants";

const SideBarr = () => {
  return (
    <Flex
      minH={"100vh"}
      w="50%"
      pt="60px"
      bgColor="#F1EBF9"
      flexDirection="column"
    >
      <Box pl="100px">
        <Image src={sidelogo} w="142px" h="45px" />
      </Box>
      <Flex justifyContent="center" align="center" mt="100px">
        <Carousel
          className="slide"
          autoPlay
          interval="5000"
          axis="horizontal"
          showStatus={false}
          transitionTime="2000"
          infiniteLoop
          showArrows={false}
          renderIndicator={(onClickHandler, isSelected, index, label) => {
            const defStyle = {
              marginLeft: 10,
              fontSize: "2rem",
              color: "white",
              cursor: "pointer",
            };
            const style = isSelected
              ? { ...defStyle, color: "#7B47CC" }
              : { ...defStyle };
            return (
              <span
                style={style}
                onClick={onClickHandler}
                onKeyDown={onClickHandler}
                value={index}
                key={index}
                role="button"
                tabIndex={0}
                aria-label={`${label} ${index + 1}`}
              >
                •
              </span>
            );
          }}
        >
          {slideshow?.map((data, i) => (
            <Box key={i} w="500px">
              <Image src={data?.img} />
            </Box>
          ))}
        </Carousel>
      </Flex>
    </Flex>
  );
};

export default SideBarr;
